module.exports = __webpack_public_path__ + "static/media/ic_setting.139e7379.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/ic_setting.svg
// module id = 676
// module chunks = 0